import React, { useContext, useMemo } from 'react';
import { Grid, InputAdornment, TextField } from '@mui/material';
import { formatValue } from '../lib/formatters';
import { ChartingCodeContext } from '../lib/chartingCodeContext';
import createLabel from '../lib/createLabel';

export const BasicInput = ({ fieldConfig, value }) => {
    const { setValue } = useContext(ChartingCodeContext);
    const htmlType = useMemo(() => {
        switch (fieldConfig.inputType) {
            case 'integer':
            case 'decimal':
                return 'number';
            case 'date':
                return 'date';
            default:
                return 'text';
        }
    }, [fieldConfig.inputType]);

    const handleFormat = (inputValue) => {
        const newValue = formatValue(inputValue, fieldConfig);

        setValue(fieldConfig.valueName, newValue);
    };

    const inputProps = useMemo(() => {
        const props = {};

        if (fieldConfig.valuePrefixLabel) {
            props.startAdornment = <InputAdornment position="start">{fieldConfig.valuePrefixLabel}</InputAdornment>;
        }
        if (fieldConfig.valueSuffixLabel) {
            props.endAdornment = <InputAdornment position="end">{fieldConfig.valueSuffixLabel}</InputAdornment>;
        }

        return props;
    }, [fieldConfig]);

    return (
        <Grid size={{ xs: fieldConfig.grid }}>
            <TextField
                fullWidth
                label={createLabel(fieldConfig)}
                variant="standard"
                type={htmlType}
                onBlur={(e) => handleFormat(e.target.value)}
                value={value}
                onChange={(e) => setValue(fieldConfig.valueName, e.target.value)}
                slotProps={{
                    inputLabel: { shrink: true },
                    htmlInput: { maxLength: fieldConfig.maxLength ?? 2000 },
                    input: inputProps,
                }}
            />
        </Grid>
    );
};

export default BasicInput;
